import UdfBoolean from "./UdfBooleanInput";
import UdfDateRange from "./UdfDateRangeInput";
import UdfDecimalRange from "./UdfDecimalRangeInput";
import UdfIntegerRange from "./UdfIntegerRangeInput";
import UdfMultiSelect from "./UdfMultiSelectInput";
import UdfSelect from "./UdfSelectInput";
import UdfText from "./UdfTextInput";

// Create component instances
const udfBooleanComponents = UdfBoolean();
const udfDateRangeComponents = UdfDateRange();
const udfDecimalRangeComponents = UdfDecimalRange();
const udfIntegerRangeComponents = UdfIntegerRange();
const udfMultiSelectComponents = UdfMultiSelect();
const udfSelectComponents = UdfSelect();
const udfTextComponents = UdfText();

// Export individual factory functions
export {
  UdfBoolean,
  UdfDateRange,
  UdfDecimalRange,
  UdfIntegerRange,
  UdfMultiSelect,
  UdfSelect,
  UdfText,
};

/**
 * Field component map for UDF filters
 * Maps field type to the appropriate Edit component
 */
export const UDF_FILTER_FIELD_COMPONENTS = {
  text: udfTextComponents.Edit,
  string: udfTextComponents.Edit,
  integer: udfIntegerRangeComponents.Edit,
  decimal: udfDecimalRangeComponents.Edit,
  number: udfIntegerRangeComponents.Edit,
  date: udfDateRangeComponents.Edit,
  boolean: udfBooleanComponents.Edit,
  select: udfSelectComponents.Edit,
  multi_select: udfMultiSelectComponents.Edit,
};

/**
 * Get display component for a field type
 * Returns a fallback component if the field type doesn't have a Display component
 *
 * @param {string} fieldType - The UDF field type
 * @returns {React.Component} Display component
 */
// Fallback display component defined outside to satisfy linter
function FallbackDisplay({ value }) {
  return String(value);
}

const UDF_DISPLAY_COMPONENTS = {
  text: udfTextComponents.Display,
  string: udfTextComponents.Display,
  integer: udfIntegerRangeComponents.Display,
  decimal: udfDecimalRangeComponents.Display,
  number: udfIntegerRangeComponents.Display,
  date: udfDateRangeComponents.Display,
  boolean: udfBooleanComponents.Display,
  select: udfSelectComponents.Display,
  multi_select: udfMultiSelectComponents.Display,
};

export function getUdfDisplayComponent(fieldType) {
  const DisplayComponent = UDF_DISPLAY_COMPONENTS[fieldType];

  if (!DisplayComponent) {
    // eslint-disable-next-line no-console
    console.warn(`No Display component for field type: ${fieldType}`);
    return FallbackDisplay;
  }

  return DisplayComponent;
}
